module.exports = __webpack_public_path__ + "static/process-detail-2b.6bbb7d72.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/process-details/process-detail-2b.png
// module id = 1490
// module chunks = 214286880276331